import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Building } from '../../interfaces/api/building';
import { BuildingFilterParameters } from '../../api/buildings';
import { fetchBuildings } from '../services/building.service';

interface BuildingState {
	buildings: Record<number, Building>;
	selectedBuilding: Building | undefined;
	isLoading: boolean;
}

const initialState: BuildingState = {
	buildings: [],
	selectedBuilding: undefined,
	isLoading: false,
};

export const fetchBuildingsThunk = createAsyncThunk<
	Building[],
	{ params: BuildingFilterParameters }
>('building/fetchBuildings', async ({ params }, { rejectWithValue }) => {
	try {
		return await fetchBuildings(params);
	} catch (error) {
		return rejectWithValue(error);
	}
});

const buildingSlice = createSlice({
	name: 'building',
	initialState,
	reducers: {
		selectBuilding: (state, action: PayloadAction<number>) => {
			state.selectedBuilding = state.buildings[action.payload];
			localStorage.setItem('selectedBuilding', String(state.buildings[action.payload].id));
		},
		unSelectBuilding: (state) => {
			state.selectedBuilding = undefined;
			localStorage.removeItem('selectedBuilding');
		},
		resetBuilding: (state) => {
			Object.assign(state, initialState);
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchBuildingsThunk.fulfilled, (state, action) => {
			const ret: Record<number, Building> = {};
			state.buildings = action.payload.reduce((obj, building) => {
				obj[building.id] = building;
				return obj;
			}, ret);
			const selectedStorageBuilding: string | null = localStorage.getItem('selectedBuilding');
			if (selectedStorageBuilding && state.buildings[Number(selectedStorageBuilding)]) {
				state.selectedBuilding = state.buildings[Number(selectedStorageBuilding)];
			}
			state.isLoading = false;
		});
		builder.addCase(fetchBuildingsThunk.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(fetchBuildingsThunk.rejected, (state, _action) => {
			state.buildings = [];
			state.isLoading = false;
		});
	},
});

export const { selectBuilding, unSelectBuilding, resetBuilding } = buildingSlice.actions;

export default buildingSlice;
